import { createFileRoute } from "@tanstack/react-router";
import {
  COMMERCIAL_COMPLIANCE_PATH,
  COMMERCIAL_COMPLIANCE_TITLE,
  LpCommercialCompliance,
} from "@/components/landing/lp-commercial-compliance";
import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const DESCRIPTION =
  "CRS Energy accreditations, insurances and renewal dates for framework and B2B procurement.";

export const Route = createFileRoute("/commercial-compliance")({
  head: () => ({
    ...pageSeo({
      path: COMMERCIAL_COMPLIANCE_PATH,
      title: `${COMMERCIAL_COMPLIANCE_TITLE} | Framework-Ready | CRS Energy`,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: COMMERCIAL_COMPLIANCE_TITLE,
        description: DESCRIPTION,
        serviceType: "Compliance & Accreditations",
        url: `${SITE.url}${COMMERCIAL_COMPLIANCE_PATH}`,
      }),
      breadcrumbJsonLdScript(
        commercialBreadcrumbTrail(COMMERCIAL_COMPLIANCE_TITLE, COMMERCIAL_COMPLIANCE_PATH),
      ),
    ],
  }),
  component: () => <LpCommercialCompliance />,
});
